var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1099 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.02539C10.6548 4.02539 10.375 4.30521 10.375 4.65039C10.375 4.99557 10.6548 5.27539 11 5.27539C11.3452 5.27539 11.625 4.99557 11.625 4.65039C11.625 4.30521 11.3452 4.02539 11 4.02539ZM9.125 4.65039C9.125 3.61486 9.96447 2.77539 11 2.77539C12.0355 2.77539 12.875 3.61486 12.875 4.65039C12.875 5.68592 12.0355 6.52539 11 6.52539C9.96447 6.52539 9.125 5.68592 9.125 4.65039Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 227 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6499 1.77405C11.2507 1.53105 10.7493 1.53105 10.3501 1.77405L2.25 6.70452V7.1852H19.75V6.70452L11.6499 1.77405ZM9.57015 0.492751C10.4484 -0.041855 11.5516 -0.0418539 12.4299 0.492751L20.89 5.64238C21.1135 5.77847 21.25 6.02128 21.25 6.28303V7.9352C21.25 8.34942 20.9142 8.6852 20.5 8.6852H19.1848V15.9451C20.3723 16.2494 21.25 17.3267 21.25 18.6091V19.5004C21.25 19.9146 20.9142 20.2504 20.5 20.2504H1.5C1.08579 20.2504 0.75 19.9146 0.75 19.5004V18.6091C0.75 17.3267 1.62775 16.2494 2.81522 15.9451V8.6852H1.5C1.08579 8.6852 0.75 8.34942 0.75 7.9352V6.28303C0.75 6.02128 0.886458 5.77847 1.11004 5.64238L9.57015 0.492751ZM4.31522 8.6852V15.8591H5.29348V8.6852H4.31522ZM6.79348 8.6852V15.8591H9.01087V8.6852H6.79348ZM10.5109 8.6852V15.8591H11.4891V8.6852H10.5109ZM12.9891 8.6852V15.8591H15.2065V8.6852H12.9891ZM16.7065 8.6852V15.8591H17.6848V8.6852H16.7065ZM3.5 17.3591C2.80964 17.3591 2.25 17.9188 2.25 18.6091V18.7504H19.75V18.6091C19.75 17.9188 19.1904 17.3591 18.5 17.3591H3.5Z",
    fill: "#221AFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBg);
export default __webpack_public_path__ + "static/media/about_bg.05093c248447f29e4e3661fdf07a3751.svg";
export { ForwardRef as ReactComponent };